@if (mensajeError) {
  <div class="alert alert-danger" role="alert">
    {{mensajeError}}
  </div>
}
<div class="body">
  <div class="container">
    <div class="rolesNoUtilizadosIf">
      <div class="row title-box mt-3">
        <div class="col-12 col-sm-12">
          <h3 class="txtbienvenida">Consulta de roles no utilizados <span class="txtbienvenida-2">Aliado
          Financiero</span></h3>
        </div>
      </div>
      <form class="custom-form" [formGroup]="filtroForm">
        <div class="row mt-2">
          <div class="col-12">
            <div class="mb-3 required form-label"
              [ngClass]="{'is-invalid':isValidForm('rolesSeleccionados')}">
              <label for="rolesSeleccionados" class="form-label">Roles asignados</label>
              <select name="miSelectRoles" class="form-control selectpicker"
                formControlName="rolesSeleccionados" title="Seleccione una opción" multiple
                [ngClass]="{'is-invalid':isValidForm('rolesSeleccionados')}" required>
                @for (item of listaRoles; track item) {
                  <option [value]="item.idRol">{{item.nombre}}</option>
                }
              </select>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="mb-3 required form-label"
              [ngClass]="{'is-invalid':isValidForm('periodoInactividad')}">
              <label for="periodoInactividad" class="form-label">Periodo inactividad (días)</label>
              <input type="text" maxlength="10" appOnlyNumbers class="form-control"
                formControlName="periodoInactividad"
                [ngClass]="{'is-invalid':isValidForm('periodoInactividad')}" required>
                <div class="invalid-feedback">
                  Campo obligatorio
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-md-center mt-3 g-3">
            <div class="col-12 col-md-2 container-btn">
              <button class="btn btn-primary hvr-shrink" [disabled]="!filtroForm.valid" style="width: 180px;"
              (click)="consultarUsuariosRolesNoUtilizados()" type="submit">Consultar</button>
            </div>
            @if (listausuarios.length > 0) {
              <div class="col-12 col-md-3 container-btn">
                <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="descargarExcelRoles()"
                type="submit">Exportar a Excel</button>
              </div>
            }
            @if (listausuarios.length > 0) {
              <div class="col-12 col-md-2 container-btn">
                <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="descargarTxtRoles()"
                type="submit">Exportar a Txt</button>
              </div>
            }
            <div class="col-12 col-md-3 container-btn">
              <button class="btn  btn-primary hvr-shrink" style="width: 180px;"
                routerLink="/intermediario/home">
                Volver
              </button>
            </div>
          </div>
        </form>
      </div>

      @if (listausuarios.length > 0) {
        <div class="row mt-4 pr-4 pl-4">
          <div class="table-responsive">
            <table class="table table-striped table-borderless rounded">
              <thead class="table_head">
                <tr>
                  <th scope="col" class="no-styles table-header" id="nombreUsuario">Nombre Usuario</th>
                  <th scope="col" class="no-styles table-header" id="tipoDoc">Tipo Documento</th>
                  <th scope="col" class="no-styles table-header" id="numeroDoc">Número Documento</th>
                  <th scope="col" class="no-styles table-header" id="numeroDoc">Roles</th>
                  <th scope="col" class="no-styles table-header" id="numeroDoc">Fecha Ultimo Ingreso</th>
                </tr>
              </thead>
              <tbody>
                @for (item of listausuarios | paginate:{itemsPerPage: 20, currentPage:pageActual}; track item) {
                  <tr>
                    <th scope="row">{{item.nombreCompleto}}</th>
                    <td>{{item.nombreDocumento}}</td>
                    <td>{{item.numeroDocumento}}</td>
                    <td>{{item.rolesConcatenados}}</td>
                    <td>{{item.fechaUltimoIngreso | date:'yyyy/MM/dd HH:mm'}}</td>
                  </tr>
                }
              </tbody>
            </table>
            <nav style="float: right;">
              <ul class="pagination">
                <li class="page-item">
                  <pagination-controls class="paginate_button" (pageChange)="pageActual = $event"
                  previousLabel='' nextLabel=''></pagination-controls>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      }
      <a id="downloadFile" style="display: none;"></a>
    </div>
    <!-- Modal -->
    <div class="modal fade text-center" id="mensajeModal" style="color: black;" tabindex="-1"
      aria-labelledby="mensajeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body justify-content-md-center">
            <div class="row">
              <div class="col-12 col-sm-12 me-3 ms-3">
                <h2>Los criterios de busqueda ingresados no arrojaron resultados en la consulta</h2>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-md-center">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Aceptar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-body"></div>
  </div>
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
